import { ChangeEvent, MouseEvent, useState } from "react";
import { SpecRowProps } from "../../../../types/product";
import { inputBase } from "../../Form/All/types";

export default function SpecRow({ spec, onChange, onRemove, isOnly }: SpecRowProps) {
    const [kFocused, setKFocused] = useState(false);
    const [vFocused, setVFocused] = useState(false);
    const rowInput = (focused: boolean): React.CSSProperties => ({
        ...inputBase,
        borderColor: focused ? "var(--or)" : "var(--border)",
        boxShadow: focused ? "0 0 0 3px rgba(191,61,12,0.10)" : "none",
    });
    return (
        <div style={{
            display: "grid", gridTemplateColumns: "1fr 1.6fr auto", gap: 8, alignItems: "center",
            background: "var(--spec-bg)", border: "1px solid var(--border)", borderRadius: 10, padding: "10px 12px",
        }}>
            <input value={spec.key}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChange({ ...spec, key: e.target.value })}
                placeholder="Attribute (e.g. Weight)" style={rowInput(kFocused)}
                onFocus={() => setKFocused(true)} onBlur={() => setKFocused(false)}
            />
            <input value={spec.value}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChange({ ...spec, value: e.target.value })}
                placeholder="Value (e.g. 142 g)" style={rowInput(vFocused)}
                onFocus={() => setVFocused(true)} onBlur={() => setVFocused(false)}
            />
            <button onClick={onRemove} disabled={isOnly} title="Remove" style={{
                width: 32, height: 32, borderRadius: 8, border: "1px solid var(--border)",
                background: "transparent", color: isOnly ? "var(--text3)" : "#e05252",
                cursor: isOnly ? "not-allowed" : "pointer", display: "flex",
                alignItems: "center", justifyContent: "center",
                fontSize: 16, opacity: isOnly ? 0.3 : 1, transition: "all 0.15s", flexShrink: 0,
            }}
                onMouseEnter={(e: MouseEvent<HTMLButtonElement>) => { if (!isOnly) e.currentTarget.style.background = "rgba(224,82,82,0.1)"; }}
                onMouseLeave={(e: MouseEvent<HTMLButtonElement>) => { e.currentTarget.style.background = "transparent"; }}
            >×</button>
        </div>
    );
}